module.exports = __webpack_public_path__ + "static/about-635bb2c623e61d0cb2911cc33d78372f.jpg";